import { SpecialPage } from 'pageModules/SpecialPage';

export default SpecialPage;
